<table class="table table-bordered table-responsive table-sm small">
  <tr>
    <th style="width: 80px">Symbol</th>
    <th style="width: 80px">Bid</th>
    <th style="width: 80px">Ask</th>
    <th style="width: 80px">Bid Size</th>
    <th style="width: 80px">Ask Size</th>
    <th style="width: 80px">Last Price</th>
    <th style="width: 80px">Last Size</th>
    <th style="width: 80px">Volatility</th>
    <th style="width: 80px">Net Change</th>
    <th style="width: 80px">Net PercentChange In Double</th>
    <th style="width: 80px">Regular Market Net Change</th>
    <th></th>
  </tr>
  <tr *ngFor="let item of QuoteData">
    <td>
      <form
        [formGroup]="addSymbolForm"
        (ngSubmit)="navigate(item.symbol)"
        style="width: 100%"
      >
        <div class="form-group">
          <button
            style="width: 100%"
            type="submit"
            class="btn btn-primary btn-block"
          >
            {{ item.symbol }}
          </button>
        </div>
      </form>
    </td>
    <td class="text-right">{{ item.bidPrice | number: "1.2" }}</td>
    <td class="text-right">{{ item.askPrice | number: "1.2" }}</td>
    <td class="text-right">
      {{ item.bidSize | number: "1.2" }}
    </td>
    <td class="text-right">
      {{ item.askSize | number: "1.2" }}
    </td>

    <td class="text-right">
      {{ item.lastPrice | number: "1.2" }}
    </td>
    <td class="text-right">
      {{ item.lastSize | number: "1.2" }}
    </td>

    <td class="text-right">{{ item.volatility | number: "1.2" }}</td>
    <td class="text-right">{{ item.netChange | number: "1.2" }}</td>
    <td class="text-right">
      {{ item.netPercentChangeInDouble | percent }}
    </td>
    <td class="text-right">
      {{ item.regularMarketNetChange | number: "1.2" }}
    </td>
    <td class="text-left">
      {{ item.description }}
    </td>
    <td>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="red"
        class="bi bi-x-square-fill"
        viewBox="0 0 16 16"
        (click)="onRemoveSymbol(item.symbol)"
      >
        <path
          d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"
        />
      </svg>
    </td>
  </tr>
</table>
<form
  [formGroup]="addSymbolForm"
  (ngSubmit)="onAddSymbol()"
  style="display: flex; justify-content: flex-start"
>
  <div class="form-group">
    <div class="input-group">
      <input
        formControlName="symbolName"
        class="form-control"
        placeholder="Symbol name"
        type="text"
      />
    </div>
  </div>
  <div class="form-group">
    <button type="submit" class="btn btn-primary btn-block">Add symbol</button>
  </div>
</form>
